/* global dataLayer Turbo */

export { trackPageView }

function load() {

  (function(w,d,s,l,i) {
    w[l] = w[l] || []
    w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'})
    var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),
      dl=l!='dataLayer'?'&l='+l:''
    j.async=true
    j.src='//www.googletagmanager.com/gtm.js?id='+i+dl
    f.parentNode.insertBefore(j,f)
  })(window, document, 'script', 'dataLayer', window.googleTagManagerId)

  let googleUrl = window.location.href
  let pageTitle = ''
  const gaPathOverride = document.getElementById('gaPathOverride')

  if(gaPathOverride){
    googleUrl = `${window.location.host}${gaPathOverride.dataset.url}`
    pageTitle = gaPathOverride.dataset.url.split('/').filter(n => n).map(n=> n.charAt(0).toUpperCase()+ n.slice(1)).join(' ')
  }

  if ((typeof Turbo !== 'undefined') && Turbo.supported) {
    document.addEventListener('turbo:load', function(){
      trackPageView(googleUrl, pageTitle)
    }, true)
  } else {
    trackPageView(googleUrl, pageTitle)
  }
}

function trackPageView(url, title = '') {
  if (!window.googleTagManagerId) { return }
  dataLayer.push({
    'event': 'virtualPageView',
    'pageUrl': url,
    'pageTitle': title
  })
}

if (window.googleTagManagerId) {
  load()
}
